import {http, api, store} from '@/libs'
import setup from '@/setup'

store.registerModule('custom', {
  namespaced: true,
  state: {
    loginCheck: false,
    token: localStorage.getItem('pcCustomToken'),
    userPromise: null,
    user: null,
    centerPages: {},
    routers: null,
  },
  mutations: {
    // 修改用户信息
    SET_USER_INFO(state, user) {
      localStorage.setItem('pcCustomToken', user.token)
      state.user = user
      state.token = user.token
      state.loginCheck = true
      store.state.main.configPromise.then(() => {
        state.centerPages = setup.rightsFilter(setup, store.state.main.config.actOnJson);
        if (!state.routers) {
          state.routers = setup.createRouter(setup, store.state.main.config.actOnJson, 'frame/frame')
        }
      })
    },

    // 注销用户
    SET_USER_LOGOUT(state) {
      localStorage.removeItem('pcCustomToken')
      state.user = null
      state.token = null
      state.routers = null
      state.loginCheck = false
    }
  },
  actions: {
    // 登录验证
    loginByToken(store, token) {
      store.state.token = token
      return http.get(api.libCustomCus.queryData).then(payload => store.commit('SET_USER_INFO', payload))
    },

    // 使用用户名密码登陆
    loginClientRegName(store, param) {
      return http.get(api.libCustom.opLoginPass, {params: param}).then(payload => store.commit('SET_USER_INFO', payload))
    },

    // 使用手机号验证码登陆
    loginClientSmsCode(store, param) {
      return http.get(api.libCustom.opLoginSms, {params: param}).then(payload => store.commit('SET_USER_INFO', payload))
    },

    // 编辑用户信息
    postOpChangeData(store, param) {
      return http.post(api.libCustomCus.opChangeData, param).then(payload => store.commit('SET_USER_INFO', payload))
    },

    // 修改用户密码
    postOpChangePass(store, param) {
      return http.post(api.libCustomCus.opChangePass, param).then(payload => store.commit('SET_USER_INFO', payload))
    },
  }
})

export default store